module.exports = __webpack_public_path__ + "media/bgm_116_jp.adfcaade.m4a";